import type { ButtonProps } from '@repo/foundations';
import { Button } from '@repo/foundations';
import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';

interface SelectorTargetProps extends ButtonProps {
	children: ReactNode;
	size?: ButtonProps['size'];
}

function SelectorTargetInternal(
	{ children, size = 'lg', ...buttonProps }: SelectorTargetProps,
	ref: ForwardedRef<HTMLButtonElement>
) {
	return (
		<Button rightIconName="selector" size={size} {...buttonProps} ref={ref}>
			{children}
		</Button>
	);
}

export const SelectorTarget = forwardRef<
	HTMLButtonElement,
	SelectorTargetProps
>(SelectorTargetInternal);
